import React from 'react';
import { LazyRender, ProductCarousel } from '@noths/polaris-client-ribbons-design-system';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import {
  getSeeAllLinkText,
  PlpPreviewProducts,
} from 'src/components/organisms/PlpPreviewProducts/PlpPreviewProducts';
import * as styles from './PlpPreviewSection.style';

export interface PlpPreviewSectionProps {
  currency: CurrencyCode;
  heading: string;
  plpUrl: string;
  trackingPosition: number;
  trackingTitle: string;
}

export const PlpPreviewSection = ({
  currency,
  heading,
  plpUrl,
  trackingPosition,
  trackingTitle,
}: PlpPreviewSectionProps) => {
  return (
    <SectionContainer columnsXL={10} maxWidth="max" wrapperStyles={styles.wrapper}>
      {/* The placeholder is server-rendered, so the PLP heading and link are in the
          initial HTML for crawlers. The endpoint fetch only starts once the block
          scrolls near the viewport and PlpPreviewProducts mounts. */}
      <LazyRender
        options={{ rootMargin: '200px' }}
        placeholder={
          <ProductCarousel
            currency={currency}
            products={null}
            subheadingLink={{ href: plpUrl, text: getSeeAllLinkText(heading) }}
            title={heading}
          />
        }
      >
        <PlpPreviewProducts
          currency={currency}
          heading={heading}
          plpUrl={plpUrl}
          trackingPosition={trackingPosition}
          trackingTitle={trackingTitle}
        />
      </LazyRender>
    </SectionContainer>
  );
};
